const carouselItems = [
  {
    title: '创造营2026赛季全景追踪：从初舞台到成团夜',
    label: '深度专题',
    desc: '全程记录本赛季128位训练生的成长轨迹，从首次亮相到第三次公演的完整复盘，附每轮排名变化与导师点评精华。关键转折点、争议事件与逆袭故事一网打尽，赛季终章前瞻成团预测。',
    img: 'https://readdy.ai/api/search-image?query=A%20stylized%20editorial%20feature%20image%20of%20a%20grand%20stage%20with%20dramatic%20spotlights%20and%20multiple%20silhouettes%20representing%20performers%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20clean%20minimalist%20composition%2C%20magazine%20cover%20aesthetic%2C%20high%20contrast%20between%20warm%20highlights%20and%20dark%20background%2C%20elegant%20gradients%2C%20professional%20editorial%20photography&width=1200&height=675&seq=carousel-01&orientation=landscape',
  },
  {
    title: '电竞世界杯：新王登基还是旧王卫冕',
    label: '赛事前瞻',
    desc: '中国区预选赛战况白热化，传统强队与新锐黑马正面交锋。深度分析各战队战术体系、选手状态与历史交锋数据，预测本届世界杯夺冠热门与潜在冷门，附完整赛程与直播时间表。',
    img: 'https://readdy.ai/api/search-image?query=A%20stylized%20esports%20tournament%20arena%20with%20dramatic%20overhead%20lighting%20and%20gaming%20stations%2C%20warm%20amber%20and%20coral%20color%20grading%2C%20minimalist%20editorial%20composition%2C%20professional%20sports%20photography%20style%2C%20abstract%20crowd%20energy%2C%20clean%20geometric%20patterns%20in%20background&width=1200&height=675&seq=carousel-02&orientation=landscape',
  },
  {
    title: '歌手2026：当经典遇上新生代，谁能定义下一个十年',
    label: '行业观察',
    desc: '从赛制改革到评审标准，从舞台设计到播出效果，全方位解读本季歌手大赛的突破与争议。独家梳理参赛歌手背景故事、选曲策略与舞台表演风格对比，深入探讨音乐竞技节目的未来走向。',
    img: 'https://readdy.ai/api/search-image?query=A%20stylized%20music%20competition%20stage%20with%20elegant%20lighting%20design%20and%20abstract%20musical%20notes%20floating%2C%20warm%20golden%20and%20coral%20color%20scheme%2C%20minimalist%20editorial%20composition%2C%20concert%20atmosphere%2C%20sophisticated%20visual%20style%20with%20soft%20gradients%2C%20professional%20magazine%20aesthetic&width=1200&height=675&seq=carousel-03&orientation=landscape',
  },
  {
    title: '年度街舞大赛：地下文化走向主流舞台的十年',
    label: '文化专题',
    desc: '从街头到聚光灯下，街舞大赛见证了中国街舞文化的崛起。回顾十年赛事历程，盘点标志性选手与经典对决，探讨商业化对街舞文化的影响，以及新一代舞者如何平衡竞技与艺术表达。',
    img: 'https://readdy.ai/api/search-image?query=A%20stylized%20dance%20studio%20with%20dynamic%20movement%20silhouettes%20and%20urban%20aesthetic%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20minimalist%20editorial%20composition%2C%20street%20dance%20culture%20vibe%2C%20abstract%20motion%20trails%2C%20professional%20photography%20with%20soft%20dramatic%20lighting&width=1200&height=675&seq=carousel-04&orientation=landscape',
  },
];

export default function SectionCarousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">深度大赛吃瓜专题报道，直击现场精彩内容</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item, i) => (
            <div key={i} className="group cursor-pointer bg-background-100 rounded-2xl overflow-hidden flex flex-col">
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 rounded-full bg-accent-500 text-white text-xs font-medium whitespace-nowrap">
                    {item.label}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6 flex-1 flex flex-col">
                <h3 className="font-heading text-lg md:text-xl text-foreground-950 mb-3 group-hover:text-primary-500 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed flex-1">{item.desc}</p>
                <span className="inline-flex items-center gap-1.5 mt-4 text-sm text-primary-500 font-medium whitespace-nowrap">
                  阅读全文
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}